import { useState, useRef } from 'react'
import isEmpty from 'lodash/isEmpty'
import { Typography } from '@material-ui/core'

import SecurityAdministrationLayout from 'components/commons/SecurityAdministrationLayout'
import UserInternalForm from './Form/UserInternalForm'
import ObservationsList from './ObservationList'

import { useStateValue } from 'context/store'
import { openSnackBarAction } from 'context/reducers/openSnackbarReducer'
import { openModalAction } from 'context/reducers/modalReducer'
import httpClient from '../../../services/HttpClient'
import { closeSpinnerAction, openSpinnerAction } from 'context/reducers/openSpinnerReducer'

const modalCommonOptions = {
   confirmButtonText: 'Entendido',
   hideCloseButton: true
}

const successModalOptions = {
   ...modalCommonOptions,
   icon: 'success',
   title: 'Registro completado con éxito',
   message: <Typography variant="body2">El proceso se realizó correctamente para todos los usuarios. </Typography>
}

const errorModalOptions = (data, didAllFail) => ({
   ...modalCommonOptions,
   icon: didAllFail ? 'error' : 'info',
   title: didAllFail ? 'Registro fallido' : 'Registro completado con observaciones',
   message: ' ',
   children: <ObservationsList data={data} didAllFail={didAllFail} />
})

const UserInternalDashboard = () => {
   const [popoverProp, setPopoverProp] = useState()
   const [_, dispatch] = useStateValue()
   const formRef = useRef()

   const resetForm = () => formRef.current?.reset()

   const saveInternalUsers = async data => {
      const url = `${process.env.REACT_APP_AUTHORIZATION_API}/user/registerbyemail`
      return await httpClient.post(url, data)
   }

   const onSubmit = async formValues => {
      dispatch(openSpinnerAction())
      try {
         const { data } = await saveInternalUsers(formValues)
         const didAllFail = data?.failed?.length == formValues?.emails?.length
         const modalData = isEmpty(data?.failed) ? successModalOptions : errorModalOptions(data, didAllFail)
         dispatch(openModalAction(modalData))
         resetForm()
      } catch (error) {
         dispatch(openSnackBarAction(error?.response?.data?.message))
      }
      dispatch(closeSpinnerAction())
   }

   return (
      <SecurityAdministrationLayout
         title="Registrar usuario interno"
         form={<UserInternalForm onSubmit={onSubmit} ref={formRef} />}
         table={null}
         setPopoverProp={setPopoverProp}
         popoverProp={popoverProp}
      />
   )
}

export default UserInternalDashboard
